module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/ts-loader/index.js!./bike-pf.cfwidget.tsx"));
	}, "bike");
}